import { StateType } from 'data/types'
import { createSelector } from 'reselect'

import { ApiCurrency, CurrencyProduct } from './types'

const selectCurrencies = (state: StateType) => state.currencies ?? {}

export const isFetching = createSelector(
  selectCurrencies,
  (currencies) => currencies.fetching ?? false
)

export const hasError = createSelector(selectCurrencies, (currencies) => currencies.error ?? false)

const isFiat = (currency: ApiCurrency) => currency.type.name === 'FIAT'

export const getCurrencies = createSelector(
  selectCurrencies,
  (currencies) => currencies.currencies ?? []
)

export const getCryptoCurrencies = createSelector(getCurrencies, (currencies) =>
  currencies.filter((c) => !isFiat(c))
)

export const getFiatCurrencies = createSelector(getCurrencies, (currencies) =>
  currencies.filter((c) => isFiat(c))
)

export const getIndexedCurrencies = createSelector(getCurrencies, (currencies) =>
  currencies.reduce((indexed, currency) => ({ ...indexed, [currency.symbol]: currency }), {})
)

export const getCurrency = (state: StateType, currency: string) =>
  getCurrencies(state).find((cur) => cur.symbol === currency)

// Taking advantage of curren return a function that can be used for different
// currencies like this:
// const getMinorUnits = getMinorUnitsFactory(state)
// now we can: getMinorUnits('USD'), getMinorUnits('BTC'), ...
export const getMinorUnitsFactory = (state: StateType) => (currency: string) =>
  10 ** (getCurrency(state, currency)?.precision ?? 2)

export const getMinorUnits = (state: StateType, currency: string) =>
  getMinorUnitsFactory(state)(currency)

export const getCurrenciesWithProduct = (product: CurrencyProduct) => (state: StateType) =>
  getCurrencies(state).filter((c) => c.products.indexOf(product) > -1)
